import React from "react";
import "./App.css";
// import app from './firebase';
// import { Routes, Route, Link } from 'react-router-dom';
import MainPage from "./components/main/main.js";
import NavBar from "./components/nav-bar/nav-bar.js";
import Footer from "./components/footer/footer.js";

function App() {
  return (
    <div className="App">
      {/* <NavBar></NavBar> */}
      <MainPage></MainPage>
      <Footer></Footer>
    </div>
  );
}

export default App;
